import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  Button,
  Input,
  Label,
  Spinner,
} from "reactstrap";

const MACHINE_ID = 74;

const PartCountByDate = () => {
  const [parts, setParts] = useState([]);
  const [selectedPart, setSelectedPart] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [totalGood, setTotalGood] = useState(null);
  const [totalBad, setTotalBad] = useState(null);
  const [loading, setLoading] = useState(false);

  // 🔹 Fetch parts list
  useEffect(() => {
    axios
      .get(`https://api.hanoch.in/api/mcc-parts/?machine_id=${MACHINE_ID}`)
      .then((res) => setParts(res?.data || []))
      .catch((err) => console.error(err));
  }, []);

  // 🔹 Submit handler
  const handleSubmit = async () => {
    if (!selectedPart || !fromDate || !toDate) {
      alert("Please select part and date range");
      return;
    }

    setLoading(true);
    setTotalGood(null);
    setTotalBad(null);

    try {
      const res = await axios.get(
        `https://api.hanoch.in/api/mcc-part-production-summary/?machine_id=${MACHINE_ID}&part_name=${selectedPart}&from_date=${fromDate}&to_date=${toDate}`,
    
      );

      const data = res.data || {};

      // ✅ Safe extraction (works even if backend wraps in `data`)
      setTotalGood(
        data.good_products ?? data?.good_products ?? 0
      );
      setTotalBad(
        data.bad_products ?? data?.bad_products ?? 0
      );
    } catch (error) {
      console.error(error);
      alert("Failed to fetch part summary");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <h5 className="mb-0">Part Count by Date Range</h5>
      </CardHeader>

      <CardBody>
        <Row className="mb-3">
          <Col md={4}>
            <Label>Part Name</Label>
            <Input
              type="select"
              value={selectedPart}
              onChange={(e) => setSelectedPart(e.target.value)}
            >
              <option value="">Select Part</option>
              {parts.map((part) => (
                <option key={part.id} value={part.part_name}>
                  {part.part_name}
                </option>
              ))}
            </Input>
          </Col>

          <Col md={3}>
            <Label>From Date</Label>
            <Input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Col>

          <Col md={4}>
            <Label>To Date</Label>
            <Input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Col>
        </Row>

        <Row className="align-items-center">
          <Col md={3}>
            <Button color="primary" onClick={handleSubmit} disabled={loading}>
              {loading ? <Spinner size="sm" /> : "Submit"}
            </Button>
          </Col>

          <Col md={4}>
            {totalGood !== null && (
              <h6 className="mb-1">
                ✅ Good Parts: <strong>{totalGood}</strong>
              </h6>
            )}
          </Col>
          <Col md={4}>
           {totalBad !== null && (
              <h6 className="mb-0 text-danger">
                ❌ Bad Parts: <strong>{totalBad}</strong>
              </h6>
            )}</Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default PartCountByDate;
